import { render, staticRenderFns } from "./DocumentacionOficialTabContent.vue?vue&type=template&id=fd3ec18e"
import script from "./DocumentacionOficialTabContent.vue?vue&type=script&lang=js"
export * from "./DocumentacionOficialTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports